import type { LangMap } from "./index";

/** Dashboard progressi della classe: trend, competenze, completamento. */
const it: Record<string, unknown> = {
  tab: "Progressi",
  trend: "Andamento della classe",
  refresh: "Aggiorna",
  delta: "{{v}} punti rispetto alla settimana scorsa",
  competencies: "Competenze",
  strong: "Rafforzate",
  weak: "Da rinforzare",
  completion: "Completamento attività",
  overall: "Media {{v}}%",
  noData: "Ancora pochi dati: appena arrivano le consegne vedrai i grafici.",
};

const en: Record<string, unknown> = {
  tab: "Progress",
  trend: "Class trend",
  refresh: "Refresh",
  delta: "{{v}} points vs last week",
  competencies: "Skills",
  strong: "Strong",
  weak: "To reinforce",
  completion: "Activity completion",
  overall: "Average {{v}}%",
  noData: "Not enough data yet: charts appear as submissions come in.",
};

const es: Record<string, unknown> = { ...en, tab: "Progreso", trend: "Evolución de la clase", competencies: "Competencias", weak: "Por reforzar", completion: "Actividades completadas" };
const fr: Record<string, unknown> = { ...en, tab: "Progrès", trend: "Évolution de la classe", competencies: "Compétences", weak: "À renforcer", completion: "Activités terminées" };
const de: Record<string, unknown> = { ...en, tab: "Fortschritt", trend: "Klassenverlauf", competencies: "Kompetenzen", weak: "Zu festigen", completion: "Abgeschlossene Aufgaben" };
const pt: Record<string, unknown> = { ...en, tab: "Progresso", trend: "Evolução da turma", competencies: "Competências", weak: "A reforçar", completion: "Atividades concluídas" };

export const progress: LangMap = { it, en, es, fr, de, pt };
